import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
class RowItemKeHoachResult extends React.Component {
  onSelected() {
    this.props.onSelected(this.props.item);
  }
  render() {
    return (
      <tr>
        <td style={{textAlign:'center'}}>{this.props.count}</td>
        <td>{this.props.item.quyetDinhPheDuyetKTTT}</td>
        <td>{this.props.item.ngayRaQuyetDinh ? moment(this.props.item.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''}</td>
        <td>{this.props.item.namThanhTra}</td>
        <td>{this.props.item.chucNangKeHoachThanhTraInfo ? this.props.item.chucNangKeHoachThanhTraInfo.text : ''}</td>
        <td>{this.props.item.nguoiKy}</td>
        <td className="action-center">
            <Link className="icon-check-file" onClick={this.onSelected.bind(this)}>Lấy thông tin kế hoạch</Link>
        </td>
      </tr>
    );
  }
}

export default RowItemKeHoachResult;


// WEBPACK FOOTER //
// ./src/components/modules/dialog/table-row/RowItemKeHoachResult.jsx